<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import PriceCard from '../parts/landingPages/priceCard.svelte';
	import { editable } from '../editable';

	interface Props {
		content: ISbStoryData<{
			title: string;
			price: string;
			interval: string;
			subline: string;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div use:editable={content}>
	<PriceCard title={content.title} interval={content.interval} price={content.price}>
		{#snippet subline()}
			<p class="text-[16px]/[140%] text-brown-3 lg:text-[18px]">{content.subline}</p>
		{/snippet}
	</PriceCard>
</div>
